export default {
  common: {
    error: "Qualcosa è andato storto",
    reload: "Ricarica",
    errorNotification: "Siamo stati informati e lo risolveremo il prima possibile. Se il problema persiste, per favore",
    contactUs: "contattaci.",
    language: "Lingua",
    loading: "Caricamento...",
    loadingText: "Caricamento",
    save: "Salva",
    savedSuccessfully: "Salvato con Successo",
    saving: "Salvataggio...",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina",
    add: "Aggiungi",
    search: "Cerca",
    filter: "Filtra",
    clear: "Cancella",
    preview: "Anteprima",
    default: "Predefinito: {{value}}",
    optional: "Opzionale",
    required: "Obbligatorio",
    noData: "Nessun dato",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Posizioni",
      cities: "Città", 
      regions: "Regioni",
      countries: "Paesi",
      showOnMap: "Mostra sulla mappa",
      addLocation: "Aggiungi posizione"
    },
    welcome: {
      title: "Benvenuto in Locations So Super.",
      subtitle: "Seleziona una sezione dalla navigazione per iniziare."
    }
  },

  // Cities section
  cities: {
    title: "Città",
    resourceSingular: "città",
    resourcePlural: "città",
    headings: {
      name: "Nome",
      status: "Stato",
      locations: "Posizioni", 
      region: "Regione",
      country: "Paese"
    },
    breadcrumbs: {
      cities: "Città"
    }
  },

  // Countries section  
  countries: {
    title: "Paesi",
    resourceSingular: "paese", 
    resourcePlural: "paesi",
    headings: {
      name: "Nome",
      status: "Stato",
      locations: "Posizioni",
      cities: "Città",
      regions: "Regioni"
    },
    breadcrumbs: {
      countries: "Paesi"
    }
  },

  // Regions section
  regions: {
    title: "Regioni",
    resourceSingular: "regione",
    resourcePlural: "regioni", 
    headings: {
      name: "Nome",
      status: "Stato",
      locations: "Posizioni",
      cities: "Città",
      country: "Paese"
    },
    breadcrumbs: {
      regions: "Regioni"
    }
  },

  // Map section
  map: {
    title: "Mappa",
    breadcrumbs: {
      locations: "Posizioni"
    }
  },

  // Import section
  import: {
    title: "Import CSV",
    breadcrumbs: {
      locations: "Posizioni"
    },
    new: {
      title: "Importa posizioni tramite CSV",
      description: "Scarica un modello CSV di esempio per vedere un esempio del formato richiesto",
      sampleTemplate: "modello CSV di esempio",
      uploadAndContinue: "Carica e continua",
      abortOnError: "Interrompi in caso di errore",
      abortOnErrorHelp: "Se c'è un errore, l'importazione si interromperà, mostrerà l'errore e nessuna posizione verrà importata.",
      needHelp: "Hai bisogno di aiuto per importare le posizioni?"
    },
    show: {
      title: "Importazione CSV",
      youCanLeavePage: "Puoi lasciare questa pagina",
      backgroundMessage: "La tua importazione continuerà a funzionare in background",
      importProgress: "Progresso importazione",
      imported: "Importate",
      suffix: "posizioni",
      importLog: "Log importazione",
      cancelImport: "Annulla importazione",
      cancelConfirmation: {
        title: "Annulla importazione",
        message: "Sei sicuro di voler annullare questo lavoro di importazione? Questa azione non può essere annullata.",
        note: "Nota: Per i lavori in corso, il lavoro dovrà essere completato e verrà eliminato subito dopo.",
        yesCancel: "Sì, annulla importazione",
        noContinue: "No, continua importazione"
      },
      report: "Rapporto",
      failedLocations: "Posizioni fallite",
      uploadAnother: "Carica un altro CSV",
      backToLocations: "Torna alle posizioni",
      importSucceeded: "Importazione riuscita",
      importFailed: "Importazione fallita"
    },
    messages: {
      uploadSuccess: "CSV caricato con successo",
      uploadError: "Impossibile caricare CSV",
      pending: "L'importazione non è ancora iniziata",
      inProgress: "Importazione in corso",
      completed: "Importazione completata",
      invalidHeader: "Le seguenti colonne sono richieste",
      invalidCsvFile: "File CSV non valido",
      aborted: "Importazione interrotta",
      failed: "Importazione fallita",
      cancelled: "Importazione annullata"
    },
    errors: {
      csvTooLarge: "Il CSV è troppo grande",
      languageNotEnabled: "La lingua '{{language}}' non è abilitata per questo negozio. Abilitala prima in Impostazioni > Lingue.",
      fieldNotTranslatable: "Il campo '{{field}}' non è traducibile. I campi traducibili sono: {{fields}}",
      locationError: "Posizione con slug: {{slug}} - {{error}}",
      planLimit: "Hai raggiunto il limite del tuo piano per le posizioni"
    }
  },

  // Location form
  location: {
    index: {
      title: "Posizioni",
      addLocation: "Aggiungi posizione",
      import: "Importa",
      noPrioritySet: "Nessuna priorità impostata",
      published: "Pubblicato",
      draft: "Bozza",
      resourceSingular: "posizione",
      resourcePlural: "posizioni",
      headings: {
        name: "Nome",
        status: "Stato", 
        city: "Città",
        region: "Regione",
        country: "Paese",
        priority: "Priorità"
      }
    },
    form: {
      title: "Aggiungi posizione",
      editTitle: "Modifica posizione",
      basicInformation: "Informazioni di base",
      name: "Nome",
      namePlaceholder: "es. Mattoni di Brian",
      nameHelpDefault: "Predefinito: {{defaultName}}",
      details: "Dettagli",
      description: "Descrizione",
      descriptionPlaceholder: "Racconta ai clienti cosa rende speciale questa posizione",
      address: "Indirizzo",
      addressPlaceholder: "123 Via Principale, Città, Paese",
      addressLine1: "Riga indirizzo 1",
      addressLine2: "Riga indirizzo 2",
      postalZipCode: "Codice postale",
      city: "Città",
      stateProvinceRegion: "Stato / Provincia / Regione",
      country: "Paese",
      phone: "Telefono",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Email", 
      emailPlaceholder: "store@example.com",
      website: "Sito web",
      websitePlaceholder: "https://www.example.com",
      image: "Immagine",
      imagePlaceholder: "Inserisci URL immagine",
      status: "Stato",
      statusActive: "Attivo",
      statusInactive: "Inattivo",
      statusDraft: "Bozza",
      priority: "Priorità",
      priorityHelpText: "Le posizioni con priorità più alta appaiono per prime nei risultati di ricerca",
      findOnMapButton: "Trova sulla mappa"
    },
    validation: {
      addressNotFound: "Indirizzo non trovato",
      createSuccess: "Posizione creata con successo", 
      updateSuccess: "Posizione aggiornata con successo",
      checkFields: "Controlla i tuoi campi",
      findOnMap: "Trova la tua posizione sulla mappa prima di salvare"
    },
    errors: {
      loading: "Errore nel caricamento della posizione"
    },
    actions: {
      save: "Salva posizione",
      delete: "Elimina posizione",
      preview: "Anteprima"
    },
    customFields: {
      title: "Campi personalizzati",
      noCustomFields: "Nessun campo personalizzato configurato",
      configureFields: "Configura campi",
      emptyState: "Non hai ancora configurato nessun campo personalizzato. I campi personalizzati ti permettono di aggiungere informazioni aggiuntive specifiche per le tue esigenze aziendali."
    },
    openingHours: {
      title: "Orari di apertura",
      checkboxLabel: "Questa posizione ha orari di apertura e chiusura",
      statusOpen: "Aperto",
      statusOpen24h: "Aperto 24h",
      statusClosed: "Chiuso",
      openingTimeLabel: "Orario di apertura",
      closingTimeLabel: "Orario di chiusura",
      days: {
        monday: "Lunedì",
        tuesday: "Martedì", 
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",
        sunday: "Domenica"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Aggiunto di recente",
        recentlyModified: "Modificato di recente"
      },
      filters: {
        status: "Stato",
        taggedWith: "Contrassegnato con",
        locationStatus: "Stato posizione",
        noTagsToShow: "Nessun tag da mostrare",
        searchPlaceholder: "Cerca"
      },
      bulkActions: {
        setPublished: "Imposta come pubblicato",
        setUnpublished: "Imposta come non pubblicato", 
        setPriority: "Imposta priorità",
        deleteLocations: "Elimina posizioni",
        exportCSV: "Esporta come CSV"
      },
      appliedFilters: {
        statusIs: "Lo stato è {{status}}",
        taggedWith: "Contrassegnato con {{tag}}",
        nameIncludes: "Il nome include {{search}}"
      },
      modals: {
        deleteTitle: "Elimina posizioni",
        deleteMessage: "Sei sicuro di voler eliminare {{count}}?",
        deleteMessageAll: "Sei sicuro di voler eliminare tutte le posizioni?",
        prioritiseTitle: "Priorizza {{count}} posizioni",
        prioritiseTitleAll: "Priorizza tutte le posizioni",
        delete: "Elimina",
        cancel: "Annulla"
      },
      emptyState: {
        noResultsHeading: "Non è stato trovato nessun {{resourcePlural}}",
        noResultsText: "Prova a cambiare i filtri o il termine di ricerca",
        noDataHeading: "Aggiungi una posizione per popolare {{resourcePlural}}",
        addLocation: "Aggiungi posizione",
        importFromCSV: "Importa da CSV"
      },
      pagination: {
        label: "Pagina {{page}} di {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Aggiornato con successo",
        deletedSuccessfully: "Eliminato con successo", 
        exportedSuccessfully: "Esportato con successo",
        error: "Qualcosa è andato storto"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Contenuto pagina",
    editTemplate: "Modifica template SEO", 
    pageTitle: "Titolo",
    pageDescription: "Descrizione",
    metaTitle: "Titolo",
    metaDescription: "Descrizione",
    urlHandle: "Handle URL",
    searchEnginePreview: "Anteprima elenco motore di ricerca",
    editMeta: "Modifica Meta",
    previewMeta: "Anteprima Meta",
    loading: "Caricamento...",
    editingLocaleHelp: "Modifica contenuto {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Template SEO",
    breadcrumbs: {
      seoTemplates: "Template SEO"
    },
    template: {
      title: "Template {{templateName}} - {{locale}}",
      discardChanges: "Scarta modifiche"
    },
    form: {
      pageContent: "Contenuto pagina",
      searchEnginePreview: "Anteprima elenco motore di ricerca",
      title: "Titolo",
      description: "Descrizione",
      pageTitle: "Titolo pagina",
      metaDescription: "Meta descrizione",
      editingLocaleHelp: "Modifica traduzioni {{locale}}. I campi vuoti mostreranno il contenuto da {{defaultLocale}}.",
      defaultValue: "Predefinito: {{value}}"
    },
    language: {
      label: "Lingua",
      defaultHelp: "Questa è la tua lingua predefinita",
      editingHelp: "Modifica traduzioni {{locale}}. I campi vuoti mostreranno il contenuto {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Lingue multiple non abilitate",
      enableInSettings: "Abilita nelle Impostazioni",
      multipleLanguagesInfo: "Per gestire template SEO per più lingue, abilita l'internazionalizzazione nelle impostazioni della lingua. Attualmente vengono mostrati solo i template {{locale}}."
    },
    badges: {
      errors: "Errori!",
      unsaved: "Non salvato"
    },
    messages: {
      saveSuccess: "Template SEO salvati con successo",
      saveError: "Impossibile salvare i template",
      error: "Errore..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Informazioni di base",
      name: "Nome",
      save: "Salva",
      saving: "Salvataggio...",
      cancel: "Annulla",
      yourLocationsIn: "Le tue posizioni in {{name}}",
      tableHeadings: {
        name: "Nome",
        status: "Stato",
        city: "Città",
        region: "Regione",
        country: "Paese"
      },
      resourceName: {
        singular: "posizione {{name}}",
        plural: "posizioni in {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mappa",
      tags: "Tag",
      customFields: "Campi personalizzati",
      languages: "Lingue",
      plan: "Piano",
      addTag: "Aggiungi tag",
      addField: "Aggiungi campo"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Scade presto"
    },
    common: {
      loading: "Caricamento...",
      error: "Errore...",
      breadcrumbs: {
        settings: "Impostazioni"
      },
      skeleton: {
        customFields: "Campi personalizzati",
        addField: "Aggiungi campo",
        name: "Nome",
        contentType: "Tipo di contenuto",
        usedIn: "Utilizzato in",
        field: "Campo",
        fields: "Campi"
      },
      messages: {
        savedSuccessfully: "Impostazioni {{setting}} salvate con successo",
        couldntSave: "Impossibile salvare le impostazioni {{setting}}"
      }
    },
    map: {
      title: "Mappa",
      messages: {
        savedSuccessfully: "Impostazioni mappa salvate con successo",
        couldntSave: "Impossibile salvare le impostazioni"
      },
      mapboxToken: {
        title: "Token Mapbox",
        description: "Inserisci il tuo token Mapbox per alimentare il tuo localizzatore di negozi",
        label: "Token Mapbox",
        placeholder: "Inserisci il token qui per continuare a utilizzare la tua mappa.",
        placeholderManaged: "Inserisci il token qui per continuare a utilizzare la tua mappa una volta esauriti i caricamenti gratuiti della mappa.",
        helpText: "Segui le nostre istruzioni per creare una chiave Mapbox, poi incolla la tua chiave sopra. Se riscontri problemi, contattaci per assistenza.",
        linkInstructions: "istruzioni per creare una chiave Mapbox",
        linkSupport: "contattaci per assistenza"
      },
      managedToken: {
        title: "Map loads",
        description: "You have up to {{max}} free map loads with a managed token, after that you will have to create your own token."
      },
      appearance: {
        title: "Appearance",
        description: "Change the visuals of your map"
      },
      mapStyle: {
        title: "Map style",
        options: {
          streets: "Streets",
          outdoors: "Outdoors", 
          light: "Light",
          dark: "Dark",
          satellite: "Satellite",
          satelliteStreets: "Satellite Streets",
          navigationDay: "Navigation Day",
          navigationNight: "Navigation Night"
        }
      },
      searchBehaviour: {
        title: "Search behaviour",
        description: "Controls how visitors find locations on your map.",
        geolocateLabel: "Automatically estimate the visitor's location and show nearby stores",
        geolocateHelp: "If geolocation succeeds, the map will move to focus near the visitor. If an estimated location can't be found, the map will remain at the starting position.",
        filterBehaviour: {
          title: "Filter behaviour",
          all: {
            label: "All tags",
            help: "For a location to show up in filters, it must have all the selected tags"
          },
          any: {
            label: "Any tags", 
            help: "For a location to show up in filters, it can have any of the selected tags"
          }
        },
        keepSearchInView: {
          label: "Keep search marker in view",
          help: "When search results appear, the map will zoom out to show all matching locations"
        },
        distanceUnits: {
          title: "Distance units",
          km: "Kilometers",
          miles: "Miles"
        },
        maxResults: {
          label: "Max results",
          help: "Limit the number of locations shown in search results",
          options: {
            results30: "30 results"
          }
        },
        maxDistance: {
          label: "Distanza massima", 
          help: "Mostra solo le posizioni entro questa distanza dal punto di ricerca",
          options: {
            unlimited: "Illimitata"
          }
        },
        showLocationNames: {
          label: "Mostra nomi delle posizioni nei suggerimenti",
          help: "Visualizza i nomi delle posizioni nei suggerimenti di ricerca"
        },
        sortByPriority: {
          label: "Ordina per priorità invece che per distanza",
          help: "Si consiglia vivamente di impostare una distanza massima (che non sia Illimitata) se questa casella è selezionata. Altrimenti i tuoi clienti vedranno posizioni lontane che hanno un'alta priorità elencate sopra quelle che sono entro una distanza ragionevole da loro (o dalla loro query di ricerca, più specificamente)."
        }
      },
      searchResults: {
        title: "Risultati di ricerca",
        description: "Controlla come le posizioni vengono restituite sulla tua mappa.",
        locationsLabel: "Testo risultati di ricerca",
        locationsHelp: "Testo mostrato sopra i risultati di ricerca (es. 'Mostrando 5 posizioni')",
        prefixLabel: "Prefisso risultati di ricerca", 
        prefixHelp: "Testo mostrato prima del numero di risultati"
      },
      popups: {
        title: "Popup",
        showPopups: {
          label: "Mostra popup",
          help: "Visualizza i dettagli della posizione quando i visitatori cliccano sui marcatori della mappa"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Nascondi testo powered by",
         hideHelp: "Rimuovi il nostro branding dal tuo localizzatore di negozi"
       }
    },
    languages: {
      title: "Lingue",
      error: "Errore...",
      messages: {
        savedSuccessfully: "Impostazioni lingua salvate con successo",
        couldntSave: "Impossibile salvare le impostazioni lingua"
      },
      banner: {
        upgradeTitle: "Il supporto multilingue richiede un upgrade del piano",
        upgradeAction: "Aggiorna a Superest",
        upgradeMessage: "Puoi ancora cambiare la tua lingua predefinita, ma abilitare più lingue richiede un upgrade.",
        disabledMessage: "Le impostazioni multilingue sono disabilitate nel tuo piano attuale"
      },
      defaultLanguage: {
        title: "Lingua predefinita", 
        description: "Scegli la tua lingua principale in cui verrà visualizzato il tuo contenuto.",
        label: "Lingua predefinita",
        help: "Questa lingua verrà utilizzata quando non viene richiesta una lingua specifica"
      },
      internationalization: {
        title: "Internazionalizzazione",
        description: "Abilita più lingue. Raggiungi più clienti e migliora il tuo SEO.",
        enableLabel: "Abilita più lingue",
        enableHelp: "Consenti ai clienti di visualizzare il tuo localizzatore di negozi in diverse lingue"
      },
      supportedLanguages: {
        title: "Lingue supportate aggiuntive",
        description: "Seleziona le lingue aggiuntive che vuoi supportare. Una volta abilitata una lingua, vedrai l'opzione per fornire traduzioni in tutta l'app. Per le lingue supportate, i modelli SEO predefiniti, così come i temi variabili comuni, verranno generati automaticamente.",
        defaultLocaleNote: "Questa è la tua lingua predefinita e non può essere disabilitata",
        shopifyEnabled: {
          label: "Questa lingua è abilitata nel mio negozio Shopify",
          importantNote: "Importante:",
          description: "Deseleziona la casella sopra se questa lingua non è abilitata e pubblicata per il tuo negozio Shopify. Si consiglia di abilitare prima la lingua per il tuo negozio Shopify andando su Impostazioni > Lingue nel tuo admin Shopify se non l'hai già fatto per un'esperienza cliente più fluida."
        },
        urlFormats: {
          cleanUrls: "URL pulite:",
          betterSeo: "Migliore SEO ed esperienza utente",
          queryUrls: "URL con parametri di query:",
          considerEnabling: "Considera di abilitare in Shopify per URL migliori"
        },
        preview: {
          button: "Anteprima",
          tooltip: "Anteprima localizzatore negozi {{language}}"
        },
        tooltips: {
          noTemplates: "Nessun modello SEO predefinito disponibile per questa lingua. Puoi creare facilmente traduzioni personalizzate."
        }
      }
    },
    tags: {
      title: "Tag",
      addTag: "Aggiungi tag",
      error: "Errore",
      messages: {
        deletedSuccessfully: "Tag eliminati con successo",
        couldntDelete: "Impossibile eliminare i tag",
        savedSuccessfully: "Tag salvato con successo",
        couldntSave: "Controlla i tuoi campi",
        tagDeleted: "Tag eliminato con successo"
      },
      resourceName: {
        singular: "tag",
        plural: "tag"
      },
      filters: {
        anyGroup: "Qualsiasi gruppo",
        inGroup: "Nel gruppo",
        tagGroup: "Gruppo tag"
      },
      appliedFilters: {
        inGroup: "Nel gruppo {{group}}",
        nameContains: "Il nome del tag contiene {{query}}"
      },
      bulkActions: {
        deleteTag: "Elimina tag",
        deleteTags: "Elimina tag"
      },
      form: {
        language: "Lingua",
        title: "Titolo",
        description: "Descrizione",
        group: "Gruppo",
        groupPlaceholder: "Seleziona gruppo",
        addGroup: "Aggiungi",
        editingTranslations: "Modifica traduzioni {{language}}. I campi vuoti mostreranno il contenuto da {{defaultLanguage}}.",
        defaultValue: "Predefinito: {{value}}",
        image: "Immagine",
        imageUrl: "URL immagine"
      },
      actions: {
        save: "Salva",
        deleteTag: "Elimina tag"
      },
      new: {
        title: "Aggiungi tag",
        messages: {
          createSuccess: "Tag creato con successo",
          checkFields: "Controlla i tuoi campi"
        },
        actions: {
          createTag: "Crea tag"
        }
      }
    },
    customFields: {
      title: "Campi personalizzati",
      addField: "Aggiungi campo",
      error: "Errore",
      resourceName: {
        singular: "Campo",
        plural: "Campi"
      },
      headings: {
        name: "Nome",
        contentType: "Tipo di contenuto",
        usedIn: "Utilizzato in"
      },
      emptyState: {
        heading: "Crea e gestisci i tuoi campi personalizzati",
        createAction: "Crea campo",
        description: "Usa i campi personalizzati per attributi unici sulle tue posizioni. Questi campi possono essere qualsiasi cosa dai profili social al nome e email del manager del negozio"
      },
      pluralization: {
        location: "posizione",
        locations: "posizioni"
      },
      form: {
        name: "Nome",
        contentType: "Tipo di contenuto",
        key: "Chiave",
        keyPrefix: "location.fields.",
        keyHelp: "Usa questa chiave per accedere al contenuto {{name}} di una posizione nei tuoi template liquid.",
        translations: {
          title: "Traduzioni",
          showTranslations: "Mostra traduzioni",
          hideTranslations: "Nascondi traduzioni",
          description: "Le traduzioni sono opzionali. I campi vuoti mostreranno il nome del campo {{language}}.",
          nameTranslation: "Nome ({{language}})",
          defaultValue: "Predefinito: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Campo salvato con successo",
        couldntSave: "Impossibile salvare il campo",
        deletedSuccessfully: "Campo eliminato con successo",
        couldntDelete: "Impossibile eliminare il campo"
      },
      actions: {
        delete: "Elimina"
      },
      new: {
        title: "Aggiungi campo",
        messages: {
          savedSuccessfully: "Campo salvato con successo",
          couldntSave: "Impossibile salvare il campo"
        }
      },
      contentTypes: {
        text: "Testo",
        textArea: "Area di testo", 
        email: "Email",
        number: "Numero",
        phoneNumber: "Numero di telefono",
        time: "Ora",
        url: "URL"
      }
    },
    plan: {
      title: "Piano",
      error: "Errore",
      changePlan: "Cambia piano",
      usdPerMonth: "USD / mese",
      sections: {
        yourPlanIncludes: "Il tuo piano include",
        nextBillingDate: "Prossima data di fatturazione",
        trial: "Prova"
      },
      banners: {
        planUpdated: "Il tuo piano è stato aggiornato",
        thankYouUpgrading: "Grazie per l'aggiornamento!",
        letUsKnow: "Facci sapere",
        improvementText: "se c'è qualcosa che possiamo fare meglio."
      },
      locations: {
        upTo: "Fino a",
        locations: "posizioni",
        unlimited: "Posizioni illimitate",
        used: "utilizzate",
        ofUsed: "{{used}} di {{max}} utilizzate"
      },
      trial: {
        daysLeft: "{{days}} giorni rimanenti",
        daysUsed: "{{used}} di {{total}} giorni utilizzati",
        selectPlan: "Seleziona un piano",
        currentPlan: "Piano attuale",
        trialBadge: "Prova",
        currentBadge: "Attuale",
        yourTrialJustStarted: "La tua prova è appena iniziata",
        trialEndsAfterToday: "La tua prova termina dopo oggi",
        trialEndsTomorrow: "La tua prova termina domani",
        daysLeftInTrial: "{{days}} giorni rimanenti nella tua prova",
        continueAddingLocations: "Continua ad aggiungere posizioni dopo {{date}} selezionando un piano",
        selectPlanToday: "Seleziona un piano oggi per continuare ad aggiungere posizioni"
      },
      footer: {
        description: "Gestisci o cambia il tuo piano Locations So Super. Visualizza i nostri",
        termsOfService: "termini di servizio",
        and: "e",
        privacyPolicy: "politica sulla privacy"
      },
      features: {
        analytics: {
          title: "Analytics",
          description: "Scopri come le persone utilizzano le tue posizioni e dove cercano"
        },
        internationalization: {
          title: "Supporto multilingue",
          description: "Migliora il SEO e raggiungi più clienti nei mercati target abilitando più lingue"
        },
        customThemes: {
          editLiquid: {
            title: "Modifica i template liquid del tema",
            description: "Visualizza i dati delle posizioni come preferisci con accesso al liquid del tema"
          },
          editStructuredData: {
            title: "Modifica i dati strutturati dell'azienda",
            description: "Modifica come Google comprende le pagine modificando i tuoi dati strutturati"
          }
        }
      },
      edit: {
        title: "Cambia piano",
        allPlansInclude: "Tutti i piani sopra includono",
        needingMoreLocations: "Hai bisogno di più posizioni?",
        footerQuestion: "Hai domande prima di iniziare?",
        sendMessage: "inviaci un messaggio",
        allFeatures: {
          seoDirectory: {
            title: "Directory SEO e pagine di destinazione",
            description: "Crea automaticamente una directory SEO di tutte le tue posizioni, città e regioni"
          },
          mapPage: {
            title: "Pagina mappa con ricerca e filtri",
            description: "Cerca e filtra tutte le tue posizioni su una mappa alimentata da mapbox"
          },
          tags: {
            title: "Tag",
            description: "Crea tag con immagini e descrizioni e raggruppali"
          },
          openingHours: {
            title: "Orari di apertura",
            description: "Imposta e visualizza gli orari di apertura per le tue posizioni"
          },
          mapStyles: {
            title: "Stili mappa",
            description: "Cambia l'aspetto delle mappe con una serie di stili predefiniti"
          },
          customFields: {
            title: "Campi personalizzati",
            description: "Aggiungi qualsiasi nuovo campo che desideri, dai link social al manager del negozio"
          },
          csvUpload: {
            title: "Carica ed esporta con CSV",
            description: "Carica e modifica in massa le tue posizioni."
          },
          richSnippets: {
            title: "Snippet ricchi",
            description: "Aiuta Google a comprendere meglio le pagine con dati strutturati di business locale"
          },
          directionsAndCalls: {
            title: "Indicazioni e chiamate",
            description: "I visitatori possono facilmente ottenere indicazioni e fare chiamate alle posizioni"
          },
          languageSupport: {
            title: "Supporto linguistico",
            description: "Cambia la lingua predefinita in qualcosa di diverso dall'inglese. Modelli di traduzione forniti per 32 lingue principali per una facile configurazione."
          }
        }
      },
      planCard: {
        bestToCustomize: "Migliore per personalizzare",
        currentPlan: "Piano attuale",
        chooseThisPlan: "Scegli questo piano",
        locationsSection: "Posizioni",
        featuresSection: "Funzionalità",
        upTo: "Fino a",
        locations: "posizioni",
        tooltipTooManyLocations: "Hai troppe posizioni e/o lingue abilitate per questo piano."
      },
      confirmation: {
        error: "Errore nella conferma del piano"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temi",
    currentTheme: {
      title: "Tema attuale",
      description: "Questo è il tema che i clienti vedono quando visitano la tua app di posizioni."
    },
    themeLibrary: {
      title: "Libreria temi", 
      description: "Gestisci i temi delle tue posizioni. Aggiungi e pubblica temi per cambiare l'aspetto della tua posizione online."
    },
    skeleton: {
      currentThemeDescription: "Questo è il tema che i tuoi clienti vedono quando usano la tua app di posizioni."
    },
    modal: {
      overrideTitle: "Sovrascrivere il tema attuale?",
      override: "Sovrascrivi",
      cancel: "Annulla",
      undoWarning: "Questa azione non può essere annullata."
    },
    messages: {
      publishSuccess: "Tema pubblicato con successo",
      publishError: "Impossibile pubblicare il tema",
      error: "Qualcosa è andato storto"
    },
    emptyStates: {
      settings: {
        heading: "Questo tema non ha impostazioni",
        description: "Crea impostazioni nell'editor di template.",
        createSettings: "Crea impostazioni",
        upgradePlan: "Aggiorna piano",
        upgradeRequired: "Aggiorna piano per creare impostazioni"
      },
      language: {
        heading: "Questo tema non ha termini linguistici",
        description: "Crea termini linguistici nell'editor di template.",
        createLanguageTerms: "Crea termini linguistici",
        upgradePlan: "Aggiorna piano",
        upgradeRequired: "Aggiorna piano per creare termini linguistici"
      }
    },
    templates: {
      categories: {
        templates: "Template",
        schemas: "Schema",
        styles: "Stili",
        liquidReference: "Riferimento Liquid"
      },
      items: {
        landing: "Landing",
        directory: "Directory",
        country: "Paese",
        region: "Regione",
        city: "Città",
        location: "Posizione",
        language: "Lingua",
        settings: "Impostazioni",
        stylesheet: "Foglio di stile"
      },
      errors: {
        errorsInTemplate: "Errori nel template",
        error: "Errore"
      },
      badges: {
        errors: "Errori!",
        unsaved: "Non salvato"
      },
      actions: {
        viewTheme: "Visualizza tema",
        discard: "Scarta",
        save: "Salva"
      }
    },
    language: {
      messages: {
        saveSuccess: "Traduzioni linguistiche del tema salvate con successo",
        saveError: "Impossibile salvare il tema"
      },
      form: {
        language: "Lingua",
        defaultLanguageHelp: "Questa è la tua lingua predefinita",
        translationHelp: "Modifica delle traduzioni per {{selectedLocale}}. I campi vuoti mostreranno il contenuto da {{defaultLocale}} (la tua lingua predefinita)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Lingue multiple non abilitate",
          action: "Abilita nelle Impostazioni",
          description: "Per gestire le traduzioni per più lingue, abilita l'internazionalizzazione nelle impostazioni della lingua. Attualmente mostrando solo le traduzioni {{locale}}."
        },
        translating: {
          title: "Traduzione da {{from}} a {{to}}",
          description: "Qualsiasi campo che lasci vuoto mostrerà automaticamente il contenuto {{defaultLocale}} ai tuoi clienti. Traduci solo i campi dove vuoi contenuto diverso in {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Accedi ai termini linguistici {{category}} in liquid con {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Titolo",
        description: "Descrizione",
        heading: "Intestazione",
        subheading: "Sottotitolo",
        button_text: "Testo del pulsante",
        link_text: "Testo del link",
        placeholder: "Segnaposto",
        label: "Etichetta",
        help_text: "Testo di aiuto",
        error_message: "Messaggio di errore",
        success_message: "Messaggio di successo",
        
        // Opening hours
        Monday: "Lunedì",
        Tuesday: "Martedì",
        Wednesday: "Mercoledì",
        Thursday: "Giovedì",
        Friday: "Venerdì",
        Saturday: "Sabato",
        Sunday: "Domenica",
        opening_hours_format: "Formato orari di apertura",
        closes_at_format: "Formato chiusura",
        opens_at_format: "Formato apertura",
        opens_on: "Apre il",
        open_24h: "Aperto 24h",
        open: "Aperto",
        closed: "Chiuso",
        closes_at: "Chiude alle",
        opens_at: "Apre alle",
        
        // Map
        search_map: "Cerca nella mappa",
        search_area: "Cerca in questa area",
        view_map: "Mappa",
        view_list: "Lista",
        open_filters: "Filtri",
        stores_near_you: "Negozi nelle vicinanze",
        header: "Trova un negozio!",
        search_placeholder: "Inserisci un codice postale o indirizzo...",
        no_listings: "Ci dispiace, non riusciamo a trovare posizioni per la tua ricerca. Prova a cambiare i filtri o la posizione di ricerca",
        
        // Directory
        view_directory: "Directory negozi",
        
        // Location
        get_directions: "Indicazioni",
        call: "Chiama",
        view_website: "Sito web",
        email: "Email",
        opening_hours_header: "Orari di apertura",
        description_header: "Informazioni",
        phone_number_header: "Telefono",
        address_header: "Indirizzo",
        tag_groups_to_display: "Gruppi di tag da visualizzare"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Generale",
        navigation: "Navigazione",
        forms: "Moduli",
        buttons: "Pulsanti",
        messages: "Messaggi",
        errors: "Errori",
        opening_hours: "Orari di apertura",
        map: "Mappa",
        directory: "Directory",
        location: "Posizione"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema salvato con successo",
        saveError: "Impossibile salvare il tema"
      },
      accessSettings: "Accedi alle impostazioni {{category}} in liquid con {{code}}",
      fields: {
        // Colors
        color_text: "Colore testo",
        color_text_heading: "Colore testo intestazione", 
        color_background: "Colore sfondo",
        color_accent: "Colore accento",
        color_text_positive: "Colore testo positivo",
        color_text_negative: "Colore testo negativo",
        dark_theme: "Tema scuro",
        color_marker: "Colore marcatore",
        color_search_marker: "Colore marcatore ricerca",
        
        // Typography
        base_font_size: "Dimensione font base",
        
        // Buttons
        border_radius: "Raggio bordo",
        
        // Images
        aspect_ratio: "Rapporto aspetto",
        fit: "Adatta",
        
        // Spacing
        page_width: "Larghezza pagina",
        page_width_small: "Larghezza pagina piccola",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobile",
        desktop_vertical_spacing: "Spaziatura verticale desktop",
        mobile_vertical_spacing: "Spaziatura verticale mobile",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Cerca durante il movimento",
        scroll_to_zoom: "Scorri per zoomare",
        
        // Landing page
        sidebar_width: "Larghezza barra laterale",
        sidebar_min_height: "Altezza minima barra laterale",
        marker_image_src: "Sorgente immagine marcatore",
        show_filter_descriptions: "Mostra descrizioni filtri",
        
        // Location page
        tag_groups_to_display: "Gruppi di tag da visualizzare",
        tag_groups_to_display_as_icons: "Gruppi di tag da visualizzare come icone",
        show_related_locations: "Mostra posizioni correlate",
        
        // Locations
        hide_regions: "Nascondi regioni"
      },
      categories: {
        colors: "Colori",
        typography: "Tipografia",
        buttons: "Pulsanti",
        images: "Immagini",
        spacing: "Spaziatura",
        breakpoints: "Breakpoint",
        map: "Mappa",
        landing_page: "Pagina di destinazione",
        location_page: "Pagina posizione",
        locations: "Posizioni"
      }
    },
    navigation: {
      sublimeTheme: "Tema Sublime",
      settings: "Impostazioni",
      language: "Lingua",
      templates: "Template",
      changeTheme: "Cambia tema",
      viewDirectory: "Visualizza directory",
      viewLandingPage: "Visualizza pagina di destinazione"
    },
    card: {
      lastUpdated: "Ultimo aggiornamento",
      view: "Visualizza",
      customize: "Personalizza",
      publish: "Pubblica",
      actions: "Azioni"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytics",
    timePeriods: {
      last7days: "Ultimi 7 giorni",
      last30days: "Ultimi 30 giorni"
    },
    comparison: {
      compareToPrevious: "Confronta con il periodo precedente",
      stopComparing: "Smetti di confrontare con il periodo precedente"
    },
    sections: {
      searchLocations: "Cerca posizioni"
    },
    cards: {
      sessions: "Sessioni",
      topSearches: "Ricerche principali",
      topLandingPageType: "Tipo pagina di destinazione principale",
      topPageViewsBySession: "Visualizzazioni pagina principali per sessione",
      topLocations: "Posizioni principali",
      topReferrers: "Referrer principali",
      searches: "Ricerche",
      topLandingPagesBySession: "Pagine di destinazione principali per sessione"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 